import { camelCase } from "lodash";
/**
 * Make CSS class names work with the P&L categories
 * we get back from askr. Right now this is a hack to
 * convert the askr classes to the same as was expected
 * when initially doing this dev
 */
export const mapPnlCategory = (key: string) => {
  if (
    ["Operation Loss", "Not Scheduled", "plantLoss", "plantloss"].includes(key)
  ) {
    return "notScheduled";
  }
  return camelCase(key);
};
